/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";

import Modal from "../components/Modal";

import {
  useDeliveriesStore,
  useLoadingStore,
  useLocationStore,
  useModalStore,
} from "../stores/hooks";

import {
  sendSmsMessageForDirect,
  sendToastMessage,
  sendUpdatedMessage,
} from "../utils/postMessages";
import { SENT_BACK_REASONS, REASON_ETC } from "../utils/sentback";

const ReasonItem = ({ active, reason, onSelect }) => {
  const handleSelect = () => {
    onSelect(reason);
  };

  return (
    <div>
      <label className="block mb-10 text-16" onClick={handleSelect}>
        <input
          type="radio"
          name="corp"
          defaultChecked={!!active}
          className="mr-5"
        />
        {reason.text}
      </label>
    </div>
  );
};

function DeliverySentBackModal({ delivery, onAfterSubmit }) {
  const { ...actions } = useDeliveriesStore();

  const { ...loadingActions } = useLoadingStore();

  const { closeModal } = useModalStore();

  const { location } = useLocationStore().state;

  const { register, handleSubmit, reset, setValue, watch } = useForm();

  const [load, setLoad] = useState(false);

  useEffect(() => {
    reset({
      code: SENT_BACK_REASONS[0].code,
      text: SENT_BACK_REASONS[0].text,
    });

    setLoad(true);
  }, []);

  // 반송완료 취소
  const handleCancel = () => {
    closeModal();
  };

  // 사유 선택
  const handleSelectReason = (reason) => {
    setValue("code", reason.code);
    setValue("text", reason.text);
    setValue("etcText", "");
  };

  // 직접입력 전체 삭제
  const handleDeleteEtcText = () => {
    setValue("etcText", "");
  };

  const onSubmit = async ({ code, text, etcText }) => {
    try {
      loadingActions.startLoading();

      const reasonText = `${text}${
        code === REASON_ETC && etcText ? `(${etcText})` : ""
      }`;

      const data = {
        reason: reasonText,
        reasonType: code,
        deliverySentBackLatitude: location.latitude,
        deliverySentBackLongitude: location.longitude,
      };

      await actions.setSentBack({
        bookId: delivery.bookId,
        data,
      });

      if (delivery.typeNormal && delivery.isNotFreshCode) {
        const message = `[두발히어로] ${delivery.bookId} ${reasonText}(으)로 반송되었습니다. 구매처나, 배송상담 카톡 채널로 문의 부탁드립니다. http://pf.kakao.com/_GxeFxnxb/chat`;

        sendSmsMessageForDirect({
          mobile: delivery.receiverSmsMobile || delivery.receiverMobile,
          message,
          bookId: delivery.bookId,
        });
      }

      sendToastMessage(`${reasonText}, 반송완료 되었습니다.`);

      sendUpdatedMessage();

      onAfterSubmit();
      closeModal();
    } catch (e) {
      window.alert(`반송완료 처리에 실패했습니다. ${e.message}`);
    }

    loadingActions.finishLoading();
  };

  return (
    <Modal>
      <div className="p-15">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="mb-20">
            <h5 className="font-medium text-18 mb-10">
              {delivery?.bookId} {delivery?.receiverName}
              <br />
              반송완료 사유를 선택해주세요.
            </h5>
            <div>
              {load &&
                SENT_BACK_REASONS.map((reason) => {
                  return (
                    <ReasonItem
                      key={reason.code}
                      active={reason.code === watch("code")}
                      reason={reason}
                      onSelect={handleSelectReason}
                    />
                  );
                })}
              <input name="code" {...register("code")} hidden />
              <input name="text" {...register("text")} hidden />
              <div className="bg-[#f6f6f6] p-5 flex justify-between items-center ml-10">
                <input
                  type="text"
                  className="bg-transparent max-w-[calc(100vw-120px)] flex-1"
                  {...register("etcText")}
                  disabled={watch("code") !== REASON_ETC}
                  maxLength={10}
                />
                <button
                  type="button"
                  className="text-16 text-[#999] p-5 w-50"
                  onClick={handleDeleteEtcText}
                >
                  삭제
                </button>
              </div>
            </div>
          </div>
          <div className="flex justify-center items-center">
            <button
              type="button"
              className="text-16 flex-1 p-10"
              onClick={handleCancel}
            >
              취소
            </button>
            <button type="submit" className="text-16 text-orange flex-1 p-10">
              확인
            </button>
          </div>
        </form>
      </div>
    </Modal>
  );
}

export default DeliverySentBackModal;
